import "./DiscountView.scss";

import React from "react";
import { Link } from "react-router-dom";
import request from "request"
import usesFeatures from "usesFeatures"

import Header from "Header"
import Switch from "Switch"
import DeleteButton from "DeleteButton"
import ImageField from "ImageField"
import DisplayField from "DisplayField"

class DiscountView extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const id = this.props.computedMatch.params.discountId
    this.props.fetchData(`venue_admin/discounts/${id}`)
  }

  toggleDiscount = (discountId) => {
    let req = request.post(`venue_admin/discounts/${discountId}/toggle`)
    req.then(() => {
      this.props.fetchData(`venue_admin/discounts/${this.props.discount.id}`)
    })
  }

  handleQuickToggle = (storeId) => {
    const discountId = this.props.discount.id
    let req = request.post("venue_admin/discounts/quick_toggle", { store_id: storeId, discount_id: discountId })
    req.then(({data}) => {
      this.props.fetchData(`venue_admin/discounts/${this.props.discount.id}`)
    })
  }


  render() {
    if (!this.props.dataFetched) return false

    const { discount, stores } = this.props
    return(
      <div className="DiscountView">
        <Header
          text="Discounts"
          backLink="/discounts"
          actions={true}
        >
          <Link to={`/discounts/${discount.id}/edit`} className="button is-primary">Edit Discount</Link>
          <DeleteButton model="Discount" id={discount.id} endpoint="discounts" />
        </Header>
        <div className="s-card mb-4">
          <div className="columns">
            <div className="column is-2">
              <Switch onChange={this.toggleDiscount.bind(null, discount.id)} value={discount.active} label="Discount Status"/>
            </div>
            <div className="column is-10">
              <h3 className="title">{ discount.name }</h3>

              <DisplayField label="Code" value={ discount.code } />
              <DisplayField label="Discount Unit" value={ discount.discountUnit } />
              <DisplayField label="Amount" value={
                discount.discountUnit === "percent" ? `${discount.discountAmount}%` : `$${discount.discountAmount}`} />
            </div>
          </div>
        </div>
        <div className="s-card mb-4">
          <h3 className="title">Stores</h3>
          { stores.map((store) => {
            return(
              <div key={store.id} className="columns">
                <div className="column">{store.name}</div>
                <div className="column is-narrow">
                  { discount.storeIds.includes(store.id) ? (
                    <span onClick={this.handleQuickToggle.bind(null, store.id)} className="button is-danger">Remove Discount</span>
                  ) : (
                    <span onClick={this.handleQuickToggle.bind(null, store.id)} className="button is-success">Add Discount</span>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default usesFeatures(["data"], DiscountView)
